import { CardsDataSourceBase } from "../../common/CardsDataSourceBase";
import { injectable } from "inversify";
import { injectToken } from "inversify-token";
import { YinzCamLoyaltyServerToken } from "yinzcam-loyalty";
import { YinzCamAPIResponse } from "yinzcam-api";

@injectable()
export class LoyaltyProgramAchievementList extends CardsDataSourceBase {
  public constructor(@injectToken(YinzCamLoyaltyServerToken) server) {
    super({ server })
  }

  protected processResponse(response: YinzCamAPIResponse): any {
    let data = (response?.data as any)?.Program.AchievementAvailable || [];
    return data;
  }
}
